class LocationOBJ{
    constructor(name, aniTimestamp){
        this.name = name;
        this.aniTimestamp = aniTimestamp;
    }
}

export default LocationOBJ;